import { BreatheRoom } from '@/components/features/wellbeing/breathing/BreatheRoom';

/** /wellbeing/breathe - one calm stage for a minute or three of breathing. */
export function BreatheRoomPage() {
  return <BreatheRoom />;
}
